function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#1CA6FF",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  strokeWidth: 2.053
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1CA6FF",
  strokeWidth: 1.12,
  d: "M37.225 32.996a.4.4 0 0 1-.344.604h-25.6a.4.4 0 0 1-.345-.604l12.8-21.6a.4.4 0 0 1 .689 0l12.8 21.6zM28.356 19.6h-8.551l-4.03 6.8h16.611l-4.03-6.8zm-4.275-7.215L20.279 18.8h7.603l-3.801-6.415zM32.86 27.2H15.3l-3.318 5.6h24.196l-3.319-5.6z"
}));

const SvgIcCloudTiering = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCloudTiering, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-cloud-tiering.64fe63ea.svg";
export { ForwardRef as ReactComponent };